import { AllHTMLAttributes, ReactNode } from "react";
import styles from "./menu-select-body.module.css";

export type MenuSelectBodyProps = {
  children: ReactNode;
  maxHeight?: string;
} & AllHTMLAttributes<HTMLDivElement>;

export function MenuSelectBody({
  children,
  maxHeight = "296px",
  ...props
}: MenuSelectBodyProps) {
  return (
    <div className={styles.Container} style={{ maxHeight }} {...props}>
      {children}
    </div>
  );
}
